import { withLayout } from '../../layout';

import PlanPage from './plan.page';

export default withLayout(PlanPage);
